<template>
  <div class="LayoutNav" :class="containerModifiers">
    <div class="LayoutNav-curtain" @click="$emit('on-close')" />

    <nav class="LayoutNav-nav">
      <div>
        <img class="LayoutNav-logo" :src="img.logo" :alt="imgAlts.logo" />
        <ul>
          <li v-for="(item, index) in items" :key="item.path">
            <template v-if="isExternal(item.path)">
              <a :href="item.path" class="LayoutNav-link" target="_blank" rel="noopener noreferrer">
                <p>{{ formatedIndex(index) }}</p>
                {{ item.text }}
              </a>
            </template>
            <template v-else>
              <router-link :to="item.path" class="LayoutNav-link">
                <p>{{ formatedIndex(index) }}</p>
                {{ item.text }}
              </router-link>
            </template>
          </li>
        </ul>
        <p class="LayoutNav-followus">{{ model.followUs }}</p>
        <div class="LayoutNav-networks">
          <a v-for="(item, index) in networks" :key="`network-${index}`" :href="item.link" target="_blank"
            @click="evSocialNetworkPush(item.name, item.social)">
            <img :src="item.logo" :alt="item.name" />
          </a>
        </div>
      </div>
      <br />
      <div>
        <a class="LayoutNav-endLink" :href="contact.to" target="_blank" @click="evClickOptionsPush('click_to_email')">{{
          contact.title }}</a>
        <br />
        <a class="LayoutNav-endLink" @click="$router.push('/politics')">{{ aviso.title }}</a>
        <br />
        <a class="LayoutNav-endLink" @click="$router.push('/tycos')">{{ tycos.title }}</a>
        <br />
        <a class="LayoutNav-endLink" @click="$router.push('/cookies')">{{ cookies.title }}</a>
        <br />
        <a v-if="showOption" class="LayoutNav-endLink" @click="openProductInfo">INFORMACIÓN DEL PRODUCTO</a>
        <br />
        <a class="LayoutNav-support" :href="model.support" target="_blank" @click="evClickOptionsPush('click_to_call')">
          <img :src="img.support" :alt="imgAlts.support" />
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import { items, networks } from "@/data/navData.js";
import model from "@/data/nav.json";
import TagFunctions from "@/assets/tagFunctions.js";

const utm = {

  utm_source: "Lata-CartaBlanca",
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp"

};

export default {
  name: "LayoutNav",
  props: {
    visible: Boolean,
  },
  data: () => ({
    items,
    networks,
    showOption: false,
    model,
    img: {
      logo: require("@/assets/img/logo.svg"),
      support: require("@/assets/img/nav/01800Cerveza.png"),
    },
  }),
  methods: {
    isExternal(path) {
      return path.startsWith('http');
    },
    formatedIndex(index) {
      return `00${index + 1}`;
    },
    openAviso(ev) {
      ev.preventDefault();
      window.dataLayer.push({ 'articleName': 'Aviso de Privacidad' });
      this.$store.commit("toggleAviso");
      this.$emit("on-close");
    },
    openTycos(ev) {
      ev.preventDefault();
      window.dataLayer.push({ 'articleName': 'Términos' });
      this.$store.commit("toggleTycos");
      this.$emit("on-close");
    },
    openCookies(ev) {
      ev.preventDefault();
      window.dataLayer.push({ 'articleName': 'Cookies' });
      this.$store.commit("toggleCookies");
      this.$emit("on-close")
    },
    openProductInfo(ev) {
      console.log('ev', ev)
      ev.preventDefault();
      window.dataLayer.push({ 'articleName': 'Modal' });
      this.$store.commit("toggleModal");
      this.$emit("on-close")
      console.log("modal producto");
    },
    evSocialNetworkPush(socialNetworkName, social) {
      this.$emit('on-close')
      if (social) {
        TagFunctions.evSocialNetworkPush(socialNetworkName)
      } else {
        TagFunctions.evClickOptionsPush('click_outboundlink')
      }
    },
    evClickOptionsPush(action) {
      if (action === 'click_to_email') {
        this.$emit('on-close')
        TagFunctions.evClickOptionsPush(action)
      } else if (action === 'click_to_call') {
        TagFunctions.evClickOptionsPush(action)
      }

    },
  },
  mounted() {

    var query = localStorage.getItem('query');

    if (query == null) {
      query = location.search
      localStorage.setItem('query', query);
    }

    const params = new URLSearchParams(query);

    query = query.replace('redirect=/&', '').replace('redirect=/', '');

    let url = query;

    history.pushState(null, "", location.href + url);

    if (
      utm["utm_source"] === params.get('utm_source') &&
      utm["utm_content"] === params.get('utm_content') &&
      utm["utm_medium"] === params.get('utm_medium')
    ) {
      console.log('Entra en el if')
      this.showOption = true;
      //  localStorage.removeItem('query'); 
    }
  },
  computed: {
    containerModifiers() {
      const { visible } = this;
      return visible ? "LayoutNav--visible" : undefined;
    },
    imgAlts() {
      const { imgAlts } = this.model;
      return imgAlts;
    },
    contact() {
      const { contact } = this.model;
      return contact;
    },
    aviso() {
      const { aviso } = this.model;
      return aviso;
    },
    tycos() {
      const { tycos } = this.model;
      return tycos;
    },
    cookies() {
      const { cookies } = this.model;
      return cookies;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './LayoutNav.styl';
</style>
